import { mapActions, mapMutations, mapState } from "vuex"
import Util from '../../util/funcoes'

export default {
  data() {
    return {
      isLoading: false
    }                                                                                                                                                                                                                        
  },

  computed: {
    ...mapState('alugueisDoDiaStore', {
      alugueisDoDia(state) { return state.listaDeAlugueisDoDia }
    }),

    tooltipQuantidadeAlugueisIsVisible() {
      return this.alugueisDoDia.length > 0;
    },

    quantidadeAlugueis() {
      const quantidade = this.alugueisDoDia.length;
      switch (quantidade) {
        case 1:
          return 'Exibindo 1 Aluguel';
      
        default:
          return `Exibindo ${quantidade} Aluguéis`;
      }
    },
  },

  created() {
    this.listar();
  },

  methods: {
    ...mapActions('alugueisDoDiaStore', [
      'recuperarAlugueisDoDia'
    ]),

    ...mapMutations('alugueisDoDiaStore', [
      'limparAlugueis'
    ]),

    listar() {
      this.showLoading();
      this.limparAlugueis();
      this.recuperarAlugueisDoDia()
      .then()
      .finally(() => {
        this.hideLoading();
      });
    },

    showLoading() {
      this.isLoading = true;
    },
    hideLoading() {
      this.isLoading = false;
    },

    formatarLabelValor(item) {
      return Util.formatarValor(item.valor);
    },
  }
}